// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

h2 {
  font-weight: 700;
  font-size: 1.75rem;
  line-height: 33px;
  font-family: "Roboto-Bold";
  margin-top: 10px;
  margin-bottom: 24px;
}

.inner-content {
  height: fit-content;
  overflow-y: auto;
}

.content {
  font-size: 16px;
  font-family: "Roboto-Regular";
  color: var(--vl-black-font);
}

.back-button-block {
  margin: 16px 0;
  margin-top: 3vh;
  padding: 0;
  align-items: center;
  justify-content: flex-end;
}
.back-button-block vl-icon {
  width: fit-content;
  padding-right: 30px;
}
.back-button-block ion-button {
  position: initial;
  margin-left: 10px;
  margin-bottom: 0;
}

.news-detail {
  margin-top: 45px;
  padding: 0 30px;
}
.news-detail img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/home-wrapper/news/news-details/news-details.page.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BDDY;ECEZ,gBAAA;EACA,mBAAA;AA0DF;;AAxDA;EACE,mBAAA;EACA,gBAAA;AA2DF;;AAxDA;EACE,eAAA;EACA,6BDTe;ECUf,2BAAA;AA2DF;;AAzDA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;AA4DF;AA3DE;EACE,kBAAA;EACA,mBAAA;AA6DJ;AA3DE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AA6DJ;;AAzDA;EACE,gBAAA;EACA,eAAA;AA4DF;AA3DE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AA6DJ","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\nh2 {\n  font-weight: 700;\n  font-size: 1.75rem;\n  line-height: 33px;\n  font-family: $roboto-bold;\n  margin-top: 10px;\n  margin-bottom: 24px;\n}\n.inner-content {\n  height: fit-content;\n  overflow-y: auto;\n}\n\n.content {\n  font-size: 16px;\n  font-family: $roboto-regular;\n  color: var(--vl-black-font);\n}\n.back-button-block{\n  margin: 16px 0;\n  margin-top: 3vh;\n  padding: 0;\n  align-items: center;\n  justify-content: flex-end;\n  vl-icon {\n    width: fit-content;\n    padding-right: 30px;\n  }\n  ion-button {\n    position: initial;\n    margin-left: 10px;\n    margin-bottom: 0;\n  }\n}\n\n.news-detail {\n  margin-top: 45px;\n  padding: 0 30px;\n  img{\n    width: 100%;\n    border-radius: 8px;\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
